import { makeRequest } from '@/base/MaRequestPooler.js'

export function setDefaultPaymentMethod(id) {
  return makeRequest(`/account/payment/payment-method/${id}/default`, { method: 'put' })
}

export function deletePaymentMethod(id) {
  return makeRequest(`/account/payment/payment-method/${id}`, { method: 'delete' })
}

export function subscribe(data) {
  return makeRequest(`/account/payment/subscribe`, {
    method: 'POST',
    data,
  })
}

export function getProductInfo(product) {
  return makeRequest(`/account/payment/product/info?product=${product}`)
}

export function getPaymentInfo() {
  return makeRequest(`/account/payment/info`)
}

export function fetchInvoiceDetails(invoiceId) {
  return makeRequest(`/account/payment/invoice-detail/${invoiceId}`)
}

export function createSetupIntent(paymentMethodId) {
  return makeRequest(`/account/payment/stripe/setup-intent?paymentMethodId=${paymentMethodId}`, { method: 'POST' })
}

export function getCouponDetails(couponId) {
  return makeRequest(`/account/payment/coupon/${couponId}`)
}

/**
 * Returns account quickbooks invoices
 * @returns {Promise<*>}
 */
export function getQBInvoices() {
  return makeRequest(`/quickbooks/invoice/account`)
}

/**
 * Download and upload given invoiceDto returns public link
 * @param invoiceDto
 * @returns {Promise<*>}
 */
export function downloadInvoiceAsPDF(invoiceDto) {
  return makeRequest('/quickbooks/invoice/download', {
    method: 'POST',
    data: invoiceDto,
  })
}
